import IRootPageLink from '@/types/IRootPageLink';
import { Avatar, Box, Text } from '@chakra-ui/react';

interface IRootPageLinkProps extends IRootPageLink {}

export default function RootPageLink(props: IRootPageLinkProps) {
	return (
		<Box
			mb="4"
			borderRadius="md"
			boxShadow="sm"
			background="gray.100"
			_hover={{ background: 'gray.200' }}
			as="a"
			href={props.link}
			px="6"
			py="5"
			display="block"
			fontWeight="600"
			overflow="hidden"
		>
			<Box
				overflow="hidden"
				display="grid"
				gridTemplateRows="1fr"
				gridTemplateColumns={props.imageUrl ? 'auto 1fr' : '1fr'}
			>
				{props.imageUrl ? (
					<Box mb="auto" display="grid" alignContent="center" pr="4">
						<Avatar size="md" src={props.imageUrl} />
					</Box>
				) : null}
				<Box w="100%" overflow="hidden">
					<Text maxW="100%" overflow="auto">
						{props.name}
					</Text>
					<Text maxW="100%" overflow="auto" color="gray.500" fontSize="xs" as="pre" fontFamily="Inter Variable">
						{props.description}
					</Text>
				</Box>
			</Box>
		</Box>
	);
}
